import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getSupplierById } from "../../Dobavljaci/modules/actions";
import {
  createOffer,
  createClient,
  getCompanies,
} from "../../WebKalkulator/modules/actions";
import { getBrands } from "../../Brendovi/modules/actions";

const mapStateToProps = (state) => ({
  state: {
    loggedUser: state.user.loggedUser,
    supplier: state.suppliersReducer.supplierToEdit?.supplier,
    companies: state.clientsReducer.companies,
    brands: state.brandReducer.brands,
  },
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getSupplierById,
      createOffer,
      createClient,
      getCompanies,
      getBrands,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
